import React from 'react'
import { VotesResultsViewProps, VoteStatus } from './../types'
import VotesResults from '../VotesResults'
import BackToListButton from '../BackToListButton'
import VoteCountdown from '../VoteCountdown'
import Button, { ButtonType } from '../../Button'
import componentStyles from './VotesResultsView.module.scss'

const VotesResultsView: React.FC<VotesResultsViewProps> = ({
  setMode,
  countdownStart,
  clearCountdown,
  endVote,
  status,
  id,
  ...vote
}) => {

  const isOpen = status === VoteStatus.open
  const openVoteControls = () => ( countdownStart
    ?
    <VoteCountdown
      countdownStart={countdownStart}
      clearCountdown={clearCountdown}
    />
    :
    <Button
      dataBdd='end-vote-btn'
      text="End poll"
      className={ componentStyles['end-button'] }
      type={ ButtonType.buttonType.button }
      onClick={() => endVote(id!)}
    >
    </Button>)


  return (
    <div data-bdd='polls-results-container'>

     <VotesResults {...vote} />
      <div>
        <BackToListButton
          setMode={ setMode }/>
        {
          isOpen ? openVoteControls() : ''
        }
      </div>
    </div>
  )
}

export default VotesResultsView
